import * as React from 'react';
import { Label } from '@cian/ui-kit';
import * as style from './styles.css';
import { EType } from '../../types/newbuilding/reliableLabel';

interface IReliableLabelV2Props {
  onReliableClick(event: React.MouseEvent<HTMLElement>): void;
  onProblemClick(event: React.MouseEvent<HTMLElement>): void;
  label: string;
  reliableType: EType;
}

export const ReliableLabel = ({ onReliableClick, onProblemClick, reliableType, label }: IReliableLabelV2Props) => {
  const isReliable = reliableType === EType.Reliable;
  const onClick = React.useMemo(() => {
    return isReliable ? onReliableClick : onProblemClick;
  }, [isReliable]);

  return (
    <div onClick={onClick} data-testid="ReliableLabel" className={style['label']}>
      <Label
        background={isReliable ? 'surface-positive-default' : 'decorative-theme-red'}
        color={isReliable ? 'decorative-theme-green' : 'text-inverted-default'}
      >
        {label}
      </Label>
    </div>
  );
};
